import { Button, Image, Popover } from '@mantine/core';

type ControllerPopoverTargetProps = {
  switchOpenedState: () => void;
};

export const ControllerPopoverTarget = ({ switchOpenedState }: ControllerPopoverTargetProps) => (
  <Popover.Target>
    <Button
      aria-label="Open Sandbox Controller"
      w={56}
      h={56}
      color="#313347"
      radius={8}
      onClick={switchOpenedState}
      p="8px 10px"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
    >
      <Image src="https://static.wayflyer.com/flyui-assets/logos/wayflyer-icon-logo-white-v3.svg" />
    </Button>
  </Popover.Target>
);
